<template lang="pug">
.col-md-9
  .card
    .table-responsive
      table.table.table-striped.mb-0
        thead.bg-secondary.text-light
          tr
            th.p-3.border-top-0.align-middle Annonceur
            th.p-3.border-top-0.align-middle Titre
            th.p-3.border-top-0.align-middle Type
            th.p-3.border-top-0.align-middle statut
            th.p-3.border-top-0.align-middle Wilaya
            th.p-3.border-top-0.align-middle Date de publication
            th.p-3.border-top-0.align-middle Date d'echéance
        tbody
          tr(v-for="listeao in listeaos")
            th.p-1.align-middle(scope='row')
              a(href="#", @click.prevent="getFicheAppel(listeao.id)") {{listeao.annonceur}}
            td.p-1.align-middle
              a(href="#", @click.prevent="getFicheAppel(listeao.id)") {{listeao.titre}}
            td.p-1.align-middle
              | {{listeao.type}}
            td.p-1.align-middle
              | {{listeao.statut}}
            td.p-1.align-middle
              | {{listeao.wilaya}} Alger
            td.p-1.align-middle
              | {{listeao.date_publication}}
            td.p-1.align-middle
              | {{listeao.date_echeance}}
</template>
<script>
// import store from './../store/DataStore'
import Vuex from 'vuex'
global.v = Vuex
export default {
  store: window.store,
  components: {},
  props: {
    listeaos: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {})
  },
  computed: {
    ...Vuex.mapGetters(['profil'])
  },
  methods: {
    ...Vuex.mapActions({
      'getProfilInfoStore': 'getProfilInfo',
      'getNotifStore': 'notifStore'
    }),
    getFicheAppel () {
      this.$router.push('/ficheappeloffre')
    },
    actionForm () {
      this.$validator.validateAll().then(() => {
        window.axios.put('url', this.profil)
          .then(response => {
          // notif sucess
            let data = {
              title: this.$i18n.t('success.titre-success'),
              text: this.$i18n.t('success.text'),
              type: 'success'
            }
            this.$notif.display(data)
          })
          .catch(e => {
          // notif erreur
            let data = {
              title: this.$i18n.t('error.titre-success'),
              text: this.$i18n.t('error.text'),
              type: 'error'
            }
            this.$notif.display(data)
          })
      })
        .catch(e => {
        // alert('error validation')
        })
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/appeloffre/resutlatrecherche.vue